import BaseService from './Base';

class TagsService extends BaseService {
  static endpoint = 'api/2.0/dynamic-forms/tags/';
}

export default TagsService;